export const CMS = {
  navHome: "nav-home-link",
  navPractices: "nav-practices-link",
  navVideos: "nav-videos-link",
  navAbout: "nav-about-link",
  navBook: "nav-book-link",
  navAdmin: "nav-admin-link",
  footerAdmin: "footer-admin-link",

  heroImageEdit: "hero-image-edit-button",
  aboutImageEdit: "about-image-edit-button",
  portraitImageEdit: "portrait-image-edit-button",
  modIconEdit: "mod-icon-edit-button",
  modIconLibraryButton: "mod-icon-library-button",
  modLearnMore: "mod-learn-more-link",
  detailHeroImageEdit: "detail-hero-image-edit-button",
  detailBodyImageEdit: "detail-body-image-edit-button",
  videoThumbEdit: "video-thumb-edit-button",
  videoLinkEdit: "video-link-edit-button",
  bookingLinkEdit: "booking-link-edit-button",

  colorToggleButton: "color-toggle-button",
  colorCrimsonInput: "color-crimson-input",
  colorInkInput: "color-ink-input",
  colorParchmentInput: "color-parchment-input",
  saveButton: "save-changes-button",
  exitEditButton: "exit-edit-mode-button",
  manageAdminsButton: "manage-admins-button",

  authEmailInput: "auth-email-input",
  authPasswordInput: "auth-password-input",
  authConfirmInput: "auth-confirm-password-input",
  authSubmitButton: "auth-submit-button",
  authError: "auth-error-message",

  adminList: "admin-list",
  adminRemoveButton: "admin-remove-button",
  adminAddNameInput: "admin-add-name-input",
  adminAddEmailInput: "admin-add-email-input",
  adminAddPasswordInput: "admin-add-password-input",
  adminAddSubmitButton: "admin-add-submit-button",

  disclaimerLabel: "disclaimer-label",
  disclaimerText: "disclaimer-text",

  navResources: "nav-resources-link",
  resourceLink: "resource-link",
  editResourcesButton: "edit-resources-button",
  resourceList: "resource-edit-list",
  resourceLabelInput: "resource-label-input",
  resourceUrlInput: "resource-url-input",
  resourceRemoveButton: "resource-remove-button",
  resourceAddButton: "resource-add-button",

  sealDragHandle: "seal-drag-handle",
  sealControls: "seal-controls",
  sealZoomIn: "seal-zoom-in-button",
  sealZoomOut: "seal-zoom-out-button",
  sealReset: "seal-reset-button",
};
